// Leyendas de los datos que la ficha del mock pinta y `loan-credit` NO tiene de dónde sacar.
// Cada una nombra SU dato y SU motivo: una leyenda genérica repetida no le dice a nadie qué falta.

/** El expediente MDM guarda estado y heartbeat, nunca telemetría del equipo. */
export const NO_DEVICE_TELEMETRY_NOTE =
    'El expediente MDM no reporta batería ni sistema operativo del equipo: solo su estado de bloqueo, cuándo se enroló y cuándo se le vio por última vez.';

/** La marca y el modelo los adjunta el lambda desde la venta; el expediente MDM no los guarda. */
export const NO_DEVICE_MODEL_NOTE =
    'El expediente MDM no guarda marca ni modelo: los adjunta el silo desde la ficha de la venta, y aquí ese cruce no llegó.';

/**
 * Los cuatro huecos del porqué de la cotización. El silo los congela al originar, así que un
 * crédito viejo —o uno originado mientras el motor todavía no los emitía— llega sin ellos.
 * AUSENTE nunca se dice como «ninguna aplicó»: eso lo afirma el arreglo vacío, no el hueco.
 */
export const NO_CANDIDATE_PLANS_NOTE =
    'Este crédito se originó sin congelar los planes que compitieron. Ausente no es «compitió uno solo»: nadie guardó la lista.';

export const NO_APPLIED_PROMOTIONS_NOTE =
    'Este crédito se originó sin congelar las promociones aplicadas. Ausente no es «ninguna aplicó»: nadie las guardó.';

export const NO_APPLIED_STORE_POLICIES_NOTE =
    'Este crédito se originó sin congelar las políticas especiales. Ausente no es «ninguna aplicó»: nadie las guardó.';

export const NO_EFFECTIVE_TERMS_NOTE =
    'Este crédito se originó sin congelar las cotas con las que se cotizó: no hay con qué afirmar cuál era el enganche mínimo ni el techo de monto.';

/** El plan es editable y versionado: sin la edición, una edición posterior deja la cuota sin porqué. */
export const NO_PLAN_VERSION_NOTE =
    'Este crédito se originó sin congelar la edición del plan. Si el plan se editó después, no hay forma de saber con qué reglas se cotizó.';
